<div class="modal-icon">
    <span class="ham-icon" icon="icon" *ngIf="!useIconShapes">
        <i class="big-icon" [ngClass]="icon"></i>
    </span>
    <span
        class="ham-icon"
        icon="icon"
        *ngIf="useIconShapes"
        hamIconShapes
        [icon]="icon"
        [size]="'regular'"
        [variant]="iconShapeVariant"
        [noHover]="true"
        [type]="'square'"
    >
    </span>
</div>

<p>{{ text }}</p>
